"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReinforcementBannerSide = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = require("../../../../../base-components/Typography/Typography");
var _Button = require("../../../../../base-components/Button/Button");
var _Icon = require("../../../../../base-components/Icon/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ReinforcementBannerSide = exports.ReinforcementBannerSide = function ReinforcementBannerSide(_ref) {
  var Component = _ref.Component,
    className = _ref.className,
    titleProps = _ref.titleProps,
    textProps = _ref.textProps,
    buttonProps = _ref.buttonProps,
    iconProps = _ref.iconProps,
    namespace = _ref.namespace,
    qeId = _ref.qeId;
  return /*#__PURE__*/_react["default"].createElement(Component, {
    className: className
  }, iconProps && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, _extends({}, iconProps, {
    qeId: "".concat(qeId, "-icon")
  })), /*#__PURE__*/_react["default"].createElement(_Typography.Typography, _extends({}, titleProps, {
    qeId: "".concat(qeId, "-title")
  })), /*#__PURE__*/_react["default"].createElement(_Typography.Typography, _extends({}, textProps, {
    qeId: "".concat(qeId, "-text")
  })), /*#__PURE__*/_react["default"].createElement(_Button.Button, _extends({}, buttonProps, {
    namespace: namespace,
    qeId: "".concat(qeId, "-button")
  })));
};
ReinforcementBannerSide.propTypes = {
  Component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string, _propTypes["default"].object]),
  className: _propTypes["default"].string,
  titleProps: _propTypes["default"].shape(_Typography.Typography.propTypes),
  textProps: _propTypes["default"].shape(_Typography.Typography.propTypes),
  buttonProps: _propTypes["default"].shape(_Button.Button.propTypes),
  iconProps: _propTypes["default"].shape(_Icon.Icon.propTypes),
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string
};
ReinforcementBannerSide.defaultProps = {
  Component: 'div',
  className: undefined,
  titleProps: {
    className: undefined,
    components: {
      title: ''
    },
    styles: {
      title: ''
    },
    ChildComponent: 'div'
  },
  textProps: {
    className: undefined,
    components: {
      description: undefined
    },
    styles: {
      description: undefined
    },
    ChildComponent: undefined
  },
  buttonProps: {
    onClick: undefined,
    className: undefined,
    children: undefined
  },
  iconProps: null,
  namespace: '',
  qeId: 'reinforcement-banner-side'
};